import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Toaster } from "sonner";

// Pages
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import DreamCapture from "./pages/DreamCapture";
import DreamDetail from "./pages/DreamDetail";
import Journal from "./pages/Journal";
import Profile from "./pages/Profile";
import Subscription from "./pages/Subscription";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import Analytics from "./pages/Analytics";
import Intelligence from "./pages/Intelligence";
import Onboarding from "./pages/Onboarding";
import AuthCallback from "./pages/AuthCallback";
import ResetPassword from "./pages/ResetPassword";

// Components
import BottomNav from "./components/BottomNav";
import ProtectedRoute from "./components/ProtectedRoute";
import AddToHomeScreen from "./components/AddToHomeScreen";

import "./App.css";

function AppRouter() {
  const location = useLocation();
  
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment for session_id (Emergent Auth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  // Check if user is in onboarding mode (profile page with onboarding state)
  const isOnboarding = location.state?.onboarding === true;
  
  const showBottomNav = !isOnboarding && ['/dashboard', '/capture', '/journal', '/profile', '/analytics', '/subscription', '/dream', '/intelligence'].some(
    path => location.pathname.startsWith(path)
  );
  
  // Debug log
  console.log('Location pathname:', location.pathname, 'showBottomNav:', showBottomNav);
  
  return (
    <>
      {showBottomNav && <BottomNav />}
      <AddToHomeScreen />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        
        <Route path="/onboarding" element={
          <ProtectedRoute>
            <Onboarding />
          </ProtectedRoute>
        } />
        
        <Route path="/dashboard" element={
          <ProtectedRoute requireOnboarding>
            <Dashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/capture" element={
          <ProtectedRoute requireOnboarding>
            <DreamCapture />
          </ProtectedRoute>
        } />
        
        <Route path="/dream/:dreamId" element={
          <ProtectedRoute requireOnboarding>
            <DreamDetail />
          </ProtectedRoute>
        } />
        
        <Route path="/journal" element={
          <ProtectedRoute requireOnboarding>
            <Journal />
          </ProtectedRoute>
        } />
        
        <Route path="/profile" element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        } />
        
        <Route path="/subscription" element={
          <ProtectedRoute>
            <Subscription />
          </ProtectedRoute>
        } />
        
        <Route path="/subscription/success" element={
          <ProtectedRoute>
            <SubscriptionSuccess />
          </ProtectedRoute>
        } />
        
        <Route path="/analytics" element={
          <ProtectedRoute requireOnboarding>
            <Analytics />
          </ProtectedRoute>
        } />
        
        <Route path="/intelligence" element={
          <ProtectedRoute requireOnboarding>
            <Intelligence />
          </ProtectedRoute>
        } />
        
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <div className="noise-overlay" />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster 
        position="top-center" 
        toastOptions={{
          style: {
            background: 'hsl(240, 25%, 10%)',
            border: '1px solid rgba(255,255,255,0.1)',
            color: 'white',
          },
        }}
      />
    </div>
  );
}

export default App;
